import Vue from 'vue';
import WorkIconButton from '@/components/global_components/buttons/WorkIconButton';
import WorkButton from "@/components/global_components/buttons/WorkButton";
import WorkActionSelectorButton from '@/components/global_components/buttons/WorkActionSelectorButton';

Vue.component('WBtn', WorkButton);
Vue.component('WIconButton', WorkIconButton);
Vue.component('WActionSelectorButton', WorkActionSelectorButton);